import { useTranslation } from 'react-i18next'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import CustomerDetailInfo from '@/common/components/CustomerDetailInfo/CustomerDetailInfo.jsx'

import { getCustomerProfile } from './helpers.js'
import * as Styles from './styles.js'

const CustomerDetailCard = ({ customerProfile, email, address }) => {
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Datos del cliente')}</CardTitle>
      <Styles.Container>
        <CustomerDetailInfo
          nameLabel="Nombre cliente"
          customerProfile={getCustomerProfile({ customerProfile, email, address })}
          address={address}
        />
      </Styles.Container>
    </Card>
  )
}

export default CustomerDetailCard
